// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "meal-1Po0s";
var _4 = "meal_header-2MXQR";
var _5 = "meal_fullSize-K35Wu";
var _6 = "meal_image-8ari6";
var _7 = "popup_image-13ojX";
var _8 = "meal_title-eMFlW";
var _9 = "meal_name-3X_99";
var _a = "meal_price-nShwQ";
var _b = "meal_footer-Mhs3e";
var _c = "meal_footer_icons-1kqhd";
var _d = "meal_count-1Zzd_";
var _e = "popup_wrapper-2jRu2";
var _f = "selector-3RjQE";
var _10 = "counters-2lGE6";
var _11 = "content-pgs5m";
var _12 = "content_row-gALON";
var _13 = "name-2_dmv";
var _14 = "content_row_trigger-2pbjW";
var _15 = "content_trigger__icon-3Neb5";
var _16 = "content_row_priceWrapper-2-jrF";
var _17 = "description_row-1L0oa";
var _18 = "totalPrice-3Uq98";
var _19 = "total-IBys2";
export { _1 as "__esModule", _2 as "mobile", _3 as "meal", _4 as "meal_header", _5 as "meal_fullSize", _6 as "meal_image", _7 as "popup_image", _8 as "meal_title", _9 as "meal_name", _a as "meal_price", _b as "meal_footer", _c as "meal_footer_icons", _d as "meal_count", _e as "popup_wrapper", _f as "selector", _10 as "counters", _11 as "content", _12 as "content_row", _13 as "name", _14 as "content_row_trigger", _15 as "content_trigger__icon", _16 as "content_row_priceWrapper", _17 as "description_row", _18 as "totalPrice", _19 as "total" }
export default { "__esModule": _1, "mobile": _2, "meal": _3, "meal_header": _4, "meal_fullSize": _5, "meal_image": _6, "popup_image": _7, "meal_title": _8, "meal_name": _9, "meal_price": _a, "meal_footer": _b, "meal_footer_icons": _c, "meal_count": _d, "popup_wrapper": _e, "selector": _f, "counters": _10, "content": _11, "content_row": _12, "name": _13, "content_row_trigger": _14, "content_trigger__icon": _15, "content_row_priceWrapper": _16, "description_row": _17, "totalPrice": _18, "total": _19 }
